import { render, staticRenderFns } from "./ActionRecords.vue?vue&type=template&id=b2949c46&scoped=true&"
import script from "./ActionRecords.vue?vue&type=script&lang=js&"
export * from "./ActionRecords.vue?vue&type=script&lang=js&"
import style0 from "./ActionRecords.vue?vue&type=style&index=0&id=b2949c46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2949c46",
  null
  
)

export default component.exports